import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { KENDO_LOADER } from '@progress/kendo-angular-indicators';

@Component({
  selector: 'maximizer-loader',
  templateUrl: './loader.component.html',
  styleUrls: ['./loader.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [KENDO_LOADER],
})
export class LoaderComponent {
  @Input() type: 'legacy' | 'kendo' = 'kendo';
}
